import { createQueryTester as t, $eq as i, $ne as n, $lt as r, $lte as e, $gt as o, $gte as s, $in as u, $nin as a, $all as h, $size as c, $regex as f, $elemMatch as l, $exists as v } from "sift";
function d() {
  return (d = Object.assign || function (t) {
    for (var i = 1; i < arguments.length; i++) {
      var n = arguments[i];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }).apply(this, arguments);
}
function y(t, i) {
  t.prototype = Object.create(i.prototype), t.prototype.constructor = t, t.__proto__ = i;
}
function p(t) {
  return Array.isArray(t) ? t : [t];
}
var b = "__caslSubjectType__";
function w(t, i) {
  if (i) if (i.hasOwnProperty(b)) {
    if (t !== i[b]) throw new Error("Trying to cast object to subject type " + t + " but previously it was casted to " + i[b]);
  } else Object.defineProperty(i, b, {
    value: t
  });
  return i;
}
function g(t) {
  if (!t) return "all";
  if ("string" == typeof t) return t;
  if (t.hasOwnProperty(b)) return t[b];
  var i = "function" == typeof t ? t : t.constructor;
  return i.modelName || i.name;
}
var j = function j(t) {
  return t;
};
function O(t) {
  return "production" !== process.env.NODE_ENV && function (t) {
    if (t.manage) throw new Error('Cannot add alias for "manage" action because it is reserved');
    Object.keys(t).forEach(function (i) {
      if (i === t[i] || Array.isArray(t[i]) && (-1 !== t[i].indexOf(i) || -1 !== t[i].indexOf("manage"))) throw new Error("Attempt to alias action to itself: " + i + " -> " + t[i]);
    });
  }(t), function (i) {
    return function (t, i) {
      for (var n = p(i), r = 0; r < n.length;) {
        var e = n[r++];
        t.hasOwnProperty(e) && (n = n.concat(t[e]));
      }
      return n;
    }(t, i);
  };
}
var $ = function () {
    function t(t, i) {
      this.t = void 0, this.i = void 0, this.action = i.resolveAction(t.actions || t.action), this.subject = t.subject, this.inverted = !!t.inverted, this.conditions = t.conditions, this.reason = t.reason, this.fields = t.fields && 0 !== t.fields.length ? p(t.fields) : void 0, "actions" in t && console.warn("Rule `actions` field is deprecated. Use `action` field instead"), this.conditions && i.conditionsMatcher && (this.t = i.conditionsMatcher(this.conditions)), this.fields && i.fieldMatcher && (this.i = i.fieldMatcher(this.fields));
    }
    var i = t.prototype;
    return i.matchesConditions = function (t) {
      return !this.t || (t && "string" != typeof t && "function" != typeof t ? this.t(t) : !this.inverted);
    }, i.matchesField = function (t) {
      return !this.i || (t ? this.i(t) : !this.inverted);
    }, t;
  }(),
  m = function () {
    function t(t) {
      this.o = void 0, this.s = !1, this.u = !1, this.o = t, this.h = this.h.bind(this);
    }
    var i = t.prototype;
    return i.h = function (t) {
      var i = t.fields,
        n = t.inverted;
      this.o = this.o && !!n, this.u || !Array.isArray(i) || i.length || (this.u = !0), !this.s && i && i.length && (this.s = !0);
    }, i.l = function (t) {
      if (this.o && console.warn("Make sure your ability has direct rules, not only inverted ones. Otherwise `ability.can` will always return `false`."), this.u && console.warn("[error in next major version]: There are rules with `fields` property being an empty array. This results in the same as not passing fields at all. Make sure to remove empty array or pass fields."), this.s && !t.fieldMatcher) throw new Error('Field level restrictions are ignored because "fieldMatcher" option is not specified. Did you unintentionally used PureAbility instead of Ability?');
    }, t;
  }(),
  E = function (t) {
    function i() {
      return t.apply(this, arguments) || this;
    }
    y(i, t);
    var n = i.prototype;
    return n.can = function () {
      var t = this.relevantRuleFor.apply(this, arguments);
      return !!t && !t.inverted;
    }, n.relevantRuleFor = function () {
      for (var t = this.rulesFor.apply(this, arguments), i = arguments.length <= 1 ? void 0 : arguments[1], n = 0; n < t.length; n++) if (t[n].matchesConditions(i)) return t[n];
      return null;
    }, n.cannot = function () {
      return !this.can.apply(this, arguments);
    }, i;
  }(function () {
    function t(t, i) {
      var n = this;
      void 0 === t && (t = []), void 0 === i && (i = {}), this.s = !1, this.v = Object.create(null), this.p = Object.create(null), this.g = Object.create(null), this.j = [], this.O = {
        conditionsMatcher: i.conditionsMatcher,
        fieldMatcher: i.fieldMatcher,
        resolveAction: i.resolveAction || j
      }, Object.defineProperty(this, "detectSubjectType", {
        value: i.detectSubjectType || i.subjectName || g
      }), Object.defineProperty(this, "rules", {
        get: function get() {
          return n.j;
        }
      }), this.update(t);
    }
    var i = t.prototype;
    return i.update = function (t) {
      var i = {
        rules: t,
        ability: this,
        target: this
      };
      this.$("update", i), this.v = Object.create(null);
      var n = new m(t.length > 0),
        r = this.m(t, n.h);
      return n.l(this.O), this.g = r, this.j = t, this.s = n.s, this.$("updated", i), this;
    }, i.m = function (t, i) {
      void 0 === i && (i = j);
      for (var n = Object.create(null), r = 0; r < t.length; r++) {
        i(t[r], r);
        for (var e = new $(t[r], this.O), o = t.length - r - 1, s = p(e.action), u = p(e.subject), a = 0; a < u.length; a++) {
          var h = this.detectSubjectType(u[a]);
          n[h] = n[h] || Object.create(null);
          for (var c = 0; c < s.length; c++) {
            var f = s[c];
            n[h][f] = n[h][f] || Object.create(null), n[h][f][o] = e;
          }
        }
      }
      return n;
    }, i.possibleRulesFor = function () {
      for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++) i[n] = arguments[n];
      var r = i[0],
        e = i[1],
        o = this.detectSubjectType(e),
        s = this.v,
        u = o + "_" + r;
      return s[u] || (s[u] = this.A(r, o)), s[u];
    }, i.A = function (t, i) {
      var n = this;
      return ("all" === i ? [i] : [i, "all"]).reduce(function (i, r) {
        var e = n.g[r];
        return e ? Object.assign(i, e[t], e.manage) : i;
      }, []).filter(Boolean);
    }, i.rulesFor = function () {
      for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++) i[n] = arguments[n];
      var r = i[0],
        e = i[1],
        o = i[2],
        s = this.possibleRulesFor(r, e);
      if (o && "string" != typeof o) throw new Error("The 3rd, `field` parameter is expected to be a string. See https://stalniy.github.io/casl/en/api/casl-ability#can-of-pure-ability for details");
      return this.s ? s.filter(function (t) {
        return t.matchesField(o);
      }) : s;
    }, i.on = function (t, i) {
      var n = this.p,
        r = !0;
      return n[t] || (n[t] = []), n[t].push(i), function () {
        if (r) {
          var e = n[t].indexOf(i);
          n[t].splice(e, 1), r = !1;
        }
      };
    }, i.$ = function (t, i) {
      var n = this.p[t];
      n && n.slice(0).forEach(function (t) {
        return t(i);
      });
    }, t;
  }()),
  A = {
    $eq: i,
    $ne: n,
    $lt: r,
    $lte: e,
    $gt: o,
    $gte: s,
    $in: u,
    $nin: a,
    $all: h,
    $size: c,
    $regex: f,
    $elemMatch: l,
    $exists: v
  };
function x(i) {
  var n = {
    operations: d({}, A, i)
  };
  return function (i) {
    return t(i, n);
  };
}
var M = x({}),
  T = /[-/\\^$+?.()|[\]{}]/g,
  _ = /\.?\*+\.?/g,
  R = /\*+/,
  S = /\./g;
function k(t, i, n) {
  var r = "*" === n[0] || "." === t[0] && "." === t[t.length - 1] ? "+" : "*",
    e = -1 === t.indexOf("**") ? "[^.]" : ".",
    o = t.replace(S, "\\$&").replace(R, e + r);
  return i + t.length === n.length ? "(?:" + o + ")?" : o;
}
function C(t, i, n) {
  return "." !== t || "*" !== n[i - 1] && "*" !== n[i + 1] ? "\\" + t : t;
}
var F = function F(t) {
    var i;
    return function (n) {
      return void 0 === i && (i = t.every(function (t) {
        return -1 === t.indexOf("*");
      }) ? null : function (t) {
        var i = t.map(function (t) {
            return t.replace(T, C).replace(_, k);
          }),
          n = i.length > 1 ? "(?:" + i.join("|") + ")" : i[0];
        return new RegExp("^" + n + "$");
      }(t)), null === i ? -1 !== t.indexOf(n) : i.test(n);
    };
  },
  q = function (t) {
    function i(i, n) {
      return t.call(this, i, d({
        conditionsMatcher: M,
        fieldMatcher: F
      }, n)) || this;
    }
    return y(i, t), i;
  }(E),
  z = function () {
    function t(t) {
      this.rule = t;
    }
    return t.prototype.because = function (t) {
      return this.rule.reason = t, this;
    }, t;
  }(),
  B = function () {
    function t(t) {
      void 0 === t && (t = E), this.rules = [], this.M = t;
      this.can = this.can.bind(this), this.cannot = this.cannot.bind(this), this.build = this.build.bind(this);
    }
    var i = t.prototype;
    return i.can = function (t, i, n, r) {
      var e = {
        action: t
      };
      return i && (e.subject = i, Array.isArray(n) || "string" == typeof n ? e.fields = n : void 0 !== n && (e.conditions = n), void 0 !== r && (e.conditions = r)), this.rules.push(e), new z(e);
    }, i.cannot = function (t, i, n, r) {
      var e = this.can(t, i, n, r);
      return e.rule.inverted = !0, e;
    }, i.build = function (t) {
      return new this.M(this.rules, t);
    }, t;
  }();
function D(t, i) {
  var n, r;
  if ("function" == typeof t) r = t, n = {};else {
    if ("function" != typeof i) throw new Error("`defineAbility` expects to receive either options and dsl function or only dsl function");
    n = t, r = i;
  }
  var e = new B(q),
    o = r(e.can, e.cannot);
  return o && "function" == typeof o.then ? o.then(function () {
    return e.build(n);
  }) : e.build(n);
}
var P = function P(t) {
    return 'Cannot execute "' + t.action + '" on "' + t.subjectType + '"';
  },
  U = function U(t) {
    this.message = t;
  };
U.prototype = Object.create(Error.prototype);
var G = function (t) {
  function i(i) {
    var n;
    return (n = t.call(this, "") || this).ability = void 0, n.field = void 0, n.ability = i, "function" == typeof Error.captureStackTrace && (n.name = "ForbiddenError", Error.captureStackTrace(function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(n), n.constructor)), n;
  }
  y(i, t), i.setDefaultMessage = function (t) {
    this.T = "string" == typeof t ? function () {
      return t;
    } : t;
  }, i.from = function (t) {
    return new this(t);
  };
  var n = i.prototype;
  return n.setMessage = function (t) {
    return this.message = t, this;
  }, n.throwUnlessCan = function () {
    var t,
      i = (t = this.ability).relevantRuleFor.apply(t, arguments);
    if (!i || i.inverted) {
      this.action = arguments.length <= 0 ? void 0 : arguments[0], this.subject = arguments.length <= 1 ? void 0 : arguments[1], this.subjectType = this.ability.detectSubjectType(arguments.length <= 1 ? void 0 : arguments[1]), this.field = arguments.length <= 2 ? void 0 : arguments[2];
      var n = i ? i.reason : "";
      throw this.message = this.message || n || this.constructor.T(this), this;
    }
  }, i;
}(U);
G.T = P;
export { q as Ability, B as AbilityBuilder, G as ForbiddenError, E as PureAbility, x as buildMongoQueryMatcher, O as createAliasResolver, D as defineAbility, g as detectSubjectType, F as fieldPatternMatcher, P as getDefaultErrorMessage, M as mongoQueryMatcher, w as subject, p as wrapArray };